import { BootgridChangeType } from "./bootgridTypes";

export default class ParameterBootgridManager {
    private $bootgrid: JQuery<HTMLElement>;

    constructor($bootgrid: JQuery<HTMLElement>) {
        this.$bootgrid = $bootgrid;
    }

    /**
     * Generates FormData for post-value-change events for a single Bootgrid.
     * @param changedRows The rows that were changed (e.g., selected, deselected, updated).
     * @param changeType The type of change that occurred.
     * @param changedPropertyName The name of the property that was changed, required for 'update' change type.
     * @returns A FormData object containing the relevant data for the change.
     */
    getPostValueChangeFormData(changedRows: object[], changeType: BootgridChangeType, changedPropertyName?: string): FormData {
        const additionalData = new FormData();
        const propertyName = this.$bootgrid.attr("data-luscinia-field-name");
        const keyColumnName = this.$bootgrid.attr("data-luscinia-keycolumnname");

        switch (changeType) {
            case BootgridChangeType.select:
            case BootgridChangeType.deselect:
                additionalData.append(propertyName + "-selectedrows", this.getSelectedRowsString());
                additionalData.append(propertyName + "-displayedrows", this.getDisplayedRowsString());
                additionalData.append(propertyName + "-aftervaluechanged-changetype", changeType);
                additionalData.append(
                    propertyName + `-aftervaluechanged-${changeType === BootgridChangeType.select ? "selectedrows" : "deselectedrows"}`,
                    changedRows.map((obj) => obj[keyColumnName]).join(",")
                );
                break;
            case BootgridChangeType.update:
                const changedRow = changedRows[0];
                if (!changedRow || !changedPropertyName) {
                    throw new Error("changedRow and changedPropertyName must be defined for update change type.");
                }
                additionalData.append(propertyName + "-aftervaluechanged-rowid", changedRow[keyColumnName]);
                additionalData.append(propertyName + "-aftervaluechanged-propertyname", changedPropertyName);
                additionalData.append(propertyName + "-aftervaluechanged-propertyvalue", changedRow[changedPropertyName]);
                additionalData.append(propertyName + "-selectedrows", this.getSelectedRowsString());
                additionalData.append(propertyName + "-displayedrows", this.getDisplayedRowsString());
                additionalData.append(propertyName + "-aftervaluechanged-changetype", changeType);
                break;

            default:
                console.warn(`Unsupported change type: ${changeType}`);
        }

        return additionalData;
    }
    private getSelectedRowsString(): string {
        const keyColumnName = this.$bootgrid.data("luscinia-keycolumnname") as string;
        const obj = (this.$bootgrid as any).bootgrid("getObject");
        const selectedRowIds: string[] = (this.$bootgrid as any).bootgrid("getSelectedRowIds");
        const selectedRows = obj.rows.filter((row) => selectedRowIds.includes(row[keyColumnName]));
        return JSON.stringify(selectedRows);
    }
    private getDisplayedRowsString(): string {
        const obj = (this.$bootgrid as any).bootgrid("getObject");
        return JSON.stringify(obj.rows);
    }
}
